export default "__VITE_ASSET__2146b800__"